import React from "react";
import Page from "@jumbo/shared/Page";

const PageNotFound = React.lazy(() => import("../pages/PageNotFound"));
const HomePage = React.lazy(() => import("../pages/HomePage"));

// Production
const ProductionLF = React.lazy(
  () => import("../pages/production/ProductionLF"),
);
const ClientOrder = React.lazy(
  () => import("../pages/production/ClientOrders"),
);

// Menus
const Catalog = React.lazy(() => import("../pages/menus/catalog"));
const Meal = React.lazy(() => import("../pages/menus/meal"));
const BlockMealSelection = React.lazy(
  () => import("../pages/menus/BlockMealSelection"),
);
const ServingInstructionIcons = React.lazy(
  () => import("../pages/menus/ServingInstructionIcons"),
);
const FoodTagsPage = React.lazy(() => import("../pages/menus/FoodTagsList"));
const MealReports = React.lazy(() => import("../pages/menus/MealReports"));

// Customer Support
const Visit = React.lazy(
  () => import("../pages/customer-support/Visits/Visits"),
);
const ScheduleVisit = React.lazy(
  () => import("../pages/customer-support/Visits/components/ScheduleVisit"),
);
const Consultation = React.lazy(
  () => import("../pages/customer-support/Consultation"),
);
const CustomerSupport = React.lazy(
  () => import("../pages/customer-support/LiveChat"),
);

// Analytics
const SaudiAnalytics = React.lazy(
  () => import("../pages/analytics/SaudiAnalytics"),
);
const LightfieldsAnalytics = React.lazy(
  () => import("../pages/customer-support/LightfieldsAnalytics"),
);
const BestSellingDetails = React.lazy(
  () => import("../pages/analytics/BestSellingDetails"),
);
const PeakAndDipDetails = React.lazy(
  () => import("../pages/analytics/PeakAndDipDetails"),
);
const RetentionDetails = React.lazy(
  () => import("../pages/analytics/RententionDetails"),
);
const BranchSalesDetails = React.lazy(
  () => import("../pages/analytics/BranchSalesDetails"),
);

// Distribution Logistics
const DistributionTasks = React.lazy(
  () => import("../pages/distribution/Distribution"),
);
const ManageDrivers = React.lazy(
  () => import("../pages/distribution/ManageDrivers"),
);
const DistributionDeliveries = React.lazy(
  () => import("../pages/distribution/Deliveries"),
);
const DeliveryPlanning = React.lazy(
  () => import("../pages/distribution/DeliveryPlanning"),
);

// Promotions
const Promotions = React.lazy(() => import("../pages/promotion/Promotions"));
const PromotionsGroup = React.lazy(
  () => import("../pages/promotion/PromotionsGroup"),
);
const AdvertisementPopup = React.lazy(
  () => import("../pages/promotion/AdvertisementPopup"),
);

// Packages
const PricePlansManagement = React.lazy(
  () => import("../pages/packages/PricePlan"),
);
const Groups = React.lazy(() => import("../pages/packages/Groups"));
const Packages = React.lazy(() => import("../pages/packages/Packages"));
const GroupThemes = React.lazy(() => import("../pages/packages/GroupThemes"));

// Numou Now
const Wallets = React.lazy(() => import("../pages/numou-now/Wallets"));
const Products = React.lazy(() => import("../pages/numou-now/Product"));
const Stocks = React.lazy(() => import("../pages/numou-now/Stock/Stock"));
const ExpressOrders = React.lazy(
  () => import("../pages/numou-now/ExpressOrders"),
);

// Permission Management
const Privileges = React.lazy(() => import("../pages/permission/Privileges"));
const PermissionList = React.lazy(
  () => import("../pages/permission/Permissions/PermissionsList"),
);
const StaffList = React.lazy(() => import("../pages/permission/Staffs/Staffs"));
const AppConfigs = React.lazy(
  () => import("../pages/permission/AppConfigurations/AppConfigurations"),
);

// Custom Meals
const Meals = React.lazy(() => import("app/pages/custom-meals/Meals"));
const SubRecipe = React.lazy(() => import("app/pages/custom-meals/SubRecipe"));
const MealTypes = React.lazy(() => import("app/pages/custom-meals/MealTypes"));
const IngredientClassification = React.lazy(
  () => import("app/pages/custom-meals/IngredientClassification"),
);
const Ingredients = React.lazy(
  () => import("app/pages/custom-meals/Ingredients"),
);

// Zone Configurations
const ZoneConfigurations = React.lazy(
  () => import("../pages/zone-config/Configurations/Configurations"),
);

// Subscriptions
const Subscription = React.lazy(() => import("../pages/subs/subscription"));
const SubscriptionTransfer = React.lazy(
  () => import("../pages/SubscriptionTransfer"),
);
const SubscriptionRequest = React.lazy(
  () => import("../pages/subs/SubscriptionRequest/Request"),
);
const SubscriptionsReports = React.lazy(
  () => import("../pages/subs/Reports/ReportsTabs"),
);

// Standalone pages
const AllergySections = React.lazy(() => import("../pages/AllergySections"));
const NotificationCampaign = React.lazy(
  () => import("../pages/NotificationCampaign"),
);
const DeliveryOrders = React.lazy(() => import("../pages/DeliveryOrder"));
const ClientsDetails = React.lazy(() => import("../pages/ClientsDetails"));

export const routesForAuthenticatedOnly = [
  {
    path: "/",
    element: <Page component={HomePage} />,
  },

  // Distribution routes
  {
    path: "/dashboards/distribution-tasks",
    element: <Page component={DistributionTasks} />,
  },
  {
    path: "/dashboards/manage-drivers",
    element: <Page component={ManageDrivers} />,
  },
  {
    path: "/dashboards/distribution-deliveries",
    element: <Page component={DistributionDeliveries} />,
  },
  {
    path: "/dashboards/distribution-delivery-planning",
    element: <Page component={DeliveryPlanning} />,
  },

  // Subscriptions routes
  {
    path: "/dashboards/subscriptions",
    element: <Page component={Subscription} />,
  },
  {
    path: "/dashboards/subscriptions/request",
    element: <Page component={SubscriptionRequest} />,
  },
  {
    path: "/dashboards/subscriptions/report",
    element: <Page component={SubscriptionsReports} />,
  },

  // Clients routes
  {
    path: "/dashboards/clients",
    element: <Page component={ClientsDetails} />,
  },

  //   Production routes
  {
    path: "/dashboards/productions",
    element: <Page component={ProductionLF} />,
  },
  // Delivery Order routes
  {
    path: "dashboards/delivery-orders",
    element: <Page component={DeliveryOrders} />,
  },
  // orders routes
  {
    path: "/dashboards/orders",
    element: <Page component={ExpressOrders} />,
  },
  {
    path: "/dashboards/saudi-analytics",
    element: <Page component={SaudiAnalytics} />,
  },
  {
    path: "/dashboards/analytics",
    element: <Page component={LightfieldsAnalytics} />,
  },
  {
    path: "/dashboards/bestselling-details",
    element: <Page component={BestSellingDetails} />,
  },
  {
    path: "/dashboards/retention-details",
    element: <Page component={RetentionDetails} />,
  },
  {
    path: "/dashboards/peakdip-details",
    element: <Page component={PeakAndDipDetails} />,
  },
  {
    path: "/dashboards/branch-sales",
    element: <Page component={BranchSalesDetails} />,
  },
  //   Menu routes
  {
    path: "/dashboards/menus/catalogs",
    element: <Page component={Catalog} />,
  },
  {
    path: "/dashboards/menus/meals",
    element: <Page component={Meal} />,
  },
  {
    path: "/dashboards/block-meal-selection",
    element: <Page component={BlockMealSelection} />,
  },
  {
    path: "dashboards/food-tags",
    element: <Page component={FoodTagsPage} />,
  },
  {
    path: "/dashboards/client/orders",
    element: <Page component={ClientOrder} />,
  },

  {
    path: "/dashboards/visits",
    element: <Page component={Visit} />,
  },
  {
    path: "/dashboards/schedule/visits",
    element: <Page component={ScheduleVisit} />,
  },
  {
    path: "/dashboards/consultations",
    element: <Page component={Consultation} />,
  },
  {
    path: "/dashboards/customerSupport",
    element: <Page component={CustomerSupport} />,
  },
  //products roots
  {
    path: "/dashboards/products",
    element: <Page component={Products} />,
  },
  {
    path: "/dashboards/stocks",
    element: <Page component={Stocks} />,
  },
  {
    path: "/dashboards/zone-configurations",
    element: <Page component={ZoneConfigurations} />,
  },
  // Promotions routes
  {
    path: "/dashboards/promotions",
    element: <Page component={Promotions} />,
  },
  {
    path: "/dashboards/group-promotions",
    element: <Page component={PromotionsGroup} />,
  },
  {
    path: "/dashboards/packages/groups",
    element: <Page component={Groups} />,
  },
  {
    path: "/dashboards/group-themes",
    element: <Page component={GroupThemes} />,
  },
  {
    path: "/dashboards/subscription-transfer",
    element: <Page component={SubscriptionTransfer} />,
  },
  // Price Plans Management
  {
    path: "/dashboards/price-plans-management",
    element: <Page component={PricePlansManagement} />,
  },
  {
    path: "/dashboards/packages",
    element: <Page component={Packages} />,
  },
  {
    path: "/dashboards/wallets",
    element: <Page component={Wallets} />,
  },
  {
    path: "/dashboards/staff-list",
    element: <Page component={StaffList} />,
  },
  {
    path: "/dashboards/permission-list",
    element: <Page component={PermissionList} />,
  },
  {
    path: "/dashboards/meal-report-tabs",
    element: <Page component={MealReports} />,
  },
  {
    path: "/dashboards/privileges",
    element: <Page component={Privileges} />,
  },
  {
    path: "/dashboards/allergy-sections",
    element: <Page component={AllergySections} />,
  },
  {
    path: "/dashboards/notification-campaign",
    element: <Page component={NotificationCampaign} />,
  },
  {
    path: "/dashboards/app-configurations",
    element: <Page component={AppConfigs} />,
  },
  {
    path: "/dashboards/addpopup",
    element: <Page component={AdvertisementPopup} />,
  },
  {
    path: "/dashboards/serving-instruction-icons",
    element: <Page component={ServingInstructionIcons} />,
  },
  {
    path: "/dashboards/custom-meals",
    element: <Page component={Meals} />,
  },
  {
    path: "/dashboards/sub-recipes",
    element: <Page component={SubRecipe} />,
  },
  {
    path: "/dashboards/meal-types",
    element: <Page component={MealTypes} />,
  },
  {
    path: "/dashboards/ingredients-classifications",
    element: <Page component={IngredientClassification} />,
  },
  {
    path: "/dashboards/ingredients",
    element: <Page component={Ingredients} />,
  },
  {
    path: "/error/500",
    element: <Page component={PageNotFound} error={500} />,
  },

  {
    path: "*",
    element: <Page component={PageNotFound} error={400} />,
  },
];
